import React, {Fragment} from 'react'
import {useLoaderData, useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import SponsoredDealsCard from './sponsored-deals-card'

const BigSavings = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const bigSavingsOnQualityItems = newHomePageData?.homepageData?.bigSavingsOnQualityItems
  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'deals-of-the-day',
    widget_place: 'top',
  })
  const translations = getTranslation(language)

  const displayItems = bigSavingsOnQualityItems && bigSavingsOnQualityItems?.length > 1

  return displayItems ? (
    <div ref={widgetRef} className={clsx('mx-auto', stylesBydomain.UTILS_MAIN_CONTAINER, 'utils_main_container')}>
      <h3 className="text-center text-xl font-semibold capitalize">{translations.Home.BigSave.title}</h3>
      <div className="no-scrollbar mt-4 flex min-h-96 flex-row gap-6 overflow-x-scroll p-2">
        {bigSavingsOnQualityItems?.map((item, i) => (
          <Fragment key={`${item.asin}-${i}`}>
            <SponsoredDealsCard productInfo={item} index={i + 1} />
          </Fragment>
        ))}
      </div>
    </div>
  ) : null
}

export default BigSavings
